export const ProductTypeCodes = Object.freeze({
  HOSPITAL_ONLY: 1,
  EXTRAS_ONLY: 2,
  PACKAGE: 3,
});

export default ProductTypeCodes;